module.exports = __webpack_public_path__ + "./docs/img/icon-error_list.af0670aaf89e504c58dbcb92df21bab2.svg";